const production = {
  madera: {
    name: 'Madera',
    templateId: 'aqt_d24dthb7kbu000dt0c2g',
  },
  rockwood: {
    name: 'Rockwood',
    templateId: 'aqt_d24e4cpd0dcg009dro1g',
  },

}

export default production;
